import { QueryClient, useQuery } from '@tanstack/react-query';
import { ActivityPointApi } from 'api/ApiHelper';
import { activityPointQueryKey } from 'queries/activityPoint/queryKey';

export const useGetActivityPointSeasonsQuery = () =>
  useQuery({ queryKey: activityPointQueryKey.activityPointSeasons, queryFn: () => ActivityPointApi.getSeasons() });

export const prefetchGetActivityPointSeasonsQuery = async (queryClient: QueryClient) =>
  queryClient.prefetchQuery({
    queryKey: activityPointQueryKey.activityPointSeasons,
    queryFn: () => ActivityPointApi.getSeasons(),
  });
